<template>
  <div :class="['HotOfferCard', tagType]">
    <OfferCardTag :type="tagType">{{ tagLabel }}</OfferCardTag>
    <OfferCard @click="$emit('action-forward-click')">
      <OfferCardBrand
        :icon-name="(partner || '').toLowerCase()"
        :artwork="false"
        @click="$emit('brand-click')"
      />
      <OfferCardHorizontalContent>
        <OfferCardLeading>
          <OfferCardLeadingTitle>
            {{ customTitleLabel || cptdOfferAmount }}
          </OfferCardLeadingTitle>
          <OfferCardLeadingCaption>
            {{ customLeadingCaptionLabel || cptdInstallmentsLabel }}
          </OfferCardLeadingCaption>
        </OfferCardLeading>
        <OfferCardAction type="ghost" @click="$emit('offer-conditions-click')">
          {{ ctaLabel }}
        </OfferCardAction>
      </OfferCardHorizontalContent>
      <OfferCardBadge>{{ cptdInterestRate }}%</OfferCardBadge>
      <OfferCardActionForward @click="$emit('action-forward-click')" />
    </OfferCard>
  </div>
</template>

<script>
import OfferCardTag from '~/aasgard/components/cards/offer-card/OfferCardTag.vue'
import OfferCard from '~/aasgard/components/cards/offer-card/OfferCard.vue'
import OfferCardBrand from '~/aasgard/components/cards/offer-card/OfferCardBrand.vue'
import OfferCardHorizontalContent from '~/aasgard/components/cards/offer-card/OfferCardHorizontalContent.vue'
import OfferCardLeading from '~/aasgard/components/cards/offer-card/OfferCardLeading.vue'
import OfferCardLeadingTitle from '~/aasgard/components/cards/offer-card/OfferCardLeadingTitle.vue'
import OfferCardLeadingCaption from '~/aasgard/components/cards/offer-card/OfferCardLeadingCaption.vue'
import OfferCardAction from '~/aasgard/components/cards/offer-card/OfferCardAction.vue'
import OfferCardBadge from '~/aasgard/components/cards/offer-card/OfferCardBadge.vue'
import OfferCardActionForward from '~/aasgard/components/cards/offer-card/OfferCardActionForward.vue'
import { parseToBRL } from '~/helpers/currency'

export default {
  name: 'HotOfferCard',
  components: {
    OfferCardActionForward,
    OfferCardBadge,
    OfferCardAction,
    OfferCardLeadingTitle,
    OfferCardLeading,
    OfferCardHorizontalContent,
    OfferCardBrand,
    OfferCard,
    OfferCardTag,
    OfferCardLeadingCaption,
  },
  props: {
    partner: {
      type: String,
      required: true,
    },
    customTitleLabel: {
      type: String,
      default: '',
    },
    amount: {
      type: Number,
      required: true,
    },
    customLeadingCaptionLabel: {
      type: String,
      default: '',
    },
    duration: {
      type: Number,
      required: true,
    },
    installmentValue: {
      type: Number,
      required: true,
    },
    interestRate: {
      type: Number,
      required: true,
    },
    tagLabel: {
      type: String,
      required: true,
    },
    tagType: {
      type: String,
      required: true,
      validator(value) {
        return [
          'info',
          'negative',
          'positive',
          'positive-light',
          'error',
          'warning',
          'warning-light',
        ].includes(value)
      },
    },
    ctaLabel: {
      type: String,
      default: 'Ver mais',
    },
  },
  emits: ['action-forward-click', 'brand-click', 'offer-conditions-click'],
  computed: {
    cptdOfferAmount() {
      if (this.customTitleLabel) {
        return this.customTitleLabel
      }
      return parseToBRL(this.amount)
    },
    cptdInstallmentsLabel() {
      if (this.customLeadingCaptionLabel) {
        return this.customLeadingCaptionLabel
      }
      return `${this.duration}x de ${parseToBRL(this.installmentValue)}`
    },
    cptdInterestRate() {
      return (this.interestRate ?? 0).toFixed(2)
    },
  },
}
</script>

<style lang="scss">
.HotOfferCard {
  position: relative;
  border-radius: 12px;

  &.neutral,
  &.NEUTRAL {
    background-color: $color-neutral-dark;
  }
  &.positive,
  &.POSITIVE {
    background-color: $color-feedback-positive;
    .OfferCard {
      border: 2px solid $color-feedback-positive;
    }
  }
  &.positive-light,
  &.POSITIVE-LIGHT {
    background-color: $color-feedback-positive-light;
  }
  &.error,
  &.ERROR {
    background-color: $color-feedback-negative-light;
  }
  &.warning,
  &.WARNING {
    background-color: $color-feedback-warning;
  }
  &.warning-light,
  &.WARNING-LIGHT {
    background-color: $color-feedback-warning-light;
  }
}
</style>
